const colors = {
  color_primary: "#333333",
  color_primarytext: "#FFFFFF",
  v2_Cerulean: "var(--primary-color)",
  v3_Cerulean: "var(--primary-color)",
  v4_Cerulean: "#00ADD1",
  color_black: "#000000",
  color_darkerGrey: "#333333",
  color_darkGrey: "#5B5B5B",
  color_mediumGrey: "#8D8D8D",
  color_lightGrey: "#D0D0D0",
  color_lighterGrey: "#E8E8E8",
  color_lightestGrey: "#F8F8F8",
  color_white: "#FFFFFF",
  color_activeBackground: "#F7ECFF",
  color_purple: "var(--primary-color)",
  color_inactiveColor: "#14CCA1",
  primaryBgColor: "var(--primary-color)",
  v2_fuzzy_brown: "#C24E4E",
  blue2D4D84: "#2D4D84",
  slack_red: '#E01E5A',
  white: 'white',
  black: 'black',
  green: '#28AE27',
  blackish_back: '#1A1A1A',
  lightBlue: '#00ADD1',
  red: 'red',
  yellow: '#F3B310',
  dark_red: '#A20000',
  color_activeColor: "var(--primary-color)",
  color_light_violet: '#F7EDFF',
  color_dark_purple: '#7413BD',
  bright_green: '#28A745',
  light_orange: '#FFD5BF80',
  dark_orange: '#AB5B00',
  new_gray: '#9CA3AF',
  blue: '#0957D0',
  bright_blue: '#007BFF',
  bright_red: '#DC3545',
  bright_yellow: '#FFC107'
};
export default colors;
